const module = { name: 'desktop/shared/videoPlayer', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile } } } = Fandango_context;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_overlay as fdOverlay } from 'base-libraries';



const Selectors = {
    ID_PREFIX: 'vd-pl-z-',
    OVERLAY: ''
}


const Styles = {
    CLOSE_BTN: 'movie-detail__video-close-btn',
    CONTAINER: 'movie-detail__video-container',
    OVERLAY: 'movie-detail__video-overlay',
}


const CustomEvents = {
    ON_MODAL_CLOSE: 'take2player:OnModalClose'
}


let lastId = null
function newId() {
    lastId = lastId === null ? Math.floor(10000 * Math.random()) : lastId + 1;
    return `${Selectors.ID_PREFIX}${lastId}`;
}
function createIframe(opts) {
    const { className, id, src, width, height } = opts || {};
    if (!src) {
        return debugLog.error(module.name, 'valid src required');
    }
    const iframe = document.createElement('iframe');
    iframe.src = src;
    iframe.id = id || newId();
    iframe.allow = 'autoplay';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';
    iframe.className = className || '';
    iframe.height = height || '192px';
    iframe.width = width || '100%';
    return iframe;
}
function show(src) {
    const iframeOpts = {
        src,
    };
    if (!isMobile) {
        Object.assign(iframeOpts, {
            width: '1122px',
            height: '637px',
        });
    }
    const iframe = createIframe(iframeOpts);
    if (!iframe) {
        return;
    }
    fdOverlay.open(iframe, {
        closeBtnStyle: Styles.CLOSE_BTN,
        closeBtnTabIndex: '0',
        containerStyle: Styles.CONTAINER,
        overlayStyle: Styles.OVERLAY,
        microModalOpts: {
            onClose(modal) {
                window.dispatchEvent(new CustomEvent(CustomEvents.ON_MODAL_CLOSE, { detail: { src } }));
                modal.remove();
            },
        },
    });
}
module.exports = {
    show
};
export default module.exports;